<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">

        <div class="b-center-main" :style="'height: '+ talentHight + 'px; padding: 60px;'">
          <div class="main-left" id="left">
            <div class="title">
              人才队伍
            </div>
            <div class="contentLeft">
              <ul class="leftNavigation">

                <li v-if="this.$route.query.type == 'sskxj'" class="clickable active"><a href="/talent?type=sskxj"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>设施科学家</a></li>
                <li v-else class="clickable"><a href="/talent?type=sskxj"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>设施科学家</a></li>

                <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>管理队伍</a></li>
                <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 15px;">闵行基地</span></a></li>
                <li v-if="this.$route.query.type == 'sysoffice'" class="clickable active"><a href="/talent?type=sysoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">实验室与技术平台</span><span style="margin-left: 30px;">办公室</span></a></li>
                <li v-else class="clickable"><a href="/talent?type=sysoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">实验室与技术平台</span><span style="margin-left: 30px;">办公室</span></a></li>

                <li v-if="this.$route.query.type == 'kxyjoffice'" class="clickable active"><a href="/talent?type=kxyjoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">科学研究办公室</span></a></li>
                <li v-else class="clickable"><a href="/talent?type=kxyjoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">科学研究办公室</span></a></li>

                <li v-if="this.$route.query.type == 'rlzyoffice'" class="clickable active"><a href="/talent?type=rlzyoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">人力资源办公室、</span><span style="margin-left: 30px;">学生培养办公室</span></a></li>
                <li v-else class="clickable"><a href="/talent?type=rlzyoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">人力资源办公室、</span><span style="margin-left: 30px;">学生培养办公室</span></a></li>

                <li v-if="this.$route.query.type == 'zhoffice'" class="clickable active"><a href="/talent?type=zhoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">综合办公室</span></a></li>
                <li v-else class="clickable"><a href="/talent?type=zhoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">综合办公室</span></a></li>

                <li v-if="this.$route.query.type == 'dwoffice'" class="clickable active"><a href="/talent?type=dwoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">对外合作办公室</span></a></li>
                <li v-else class="clickable"><a href="/talent?type=dwoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">对外合作办公室</span></a></li>

              </ul>
            </div>
          </div>

          <div class="main-right" id="right">
          <p style="text-align: left; margin-bottom: 30px; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">{{ type }}</span></p>

            <div class="right-nr">
            <div class="main-tcc">
              <div class="m-p fl" style="display: block;">
                <p>以下排序为姓氏拼音首字母顺序</p>
              </div>
              <div class="main-css fr">
                <div class="searchbg1">
                  <div class="fl">
                    <input type="text" class="inp-text" name="" id="exactName" placeholder=" 姓名查找 ">
                    <input type="hidden" class="inp-text" id="queryType" value>
                  </div>
                  <div class="fr">
<!--                    <input type="button" class="inp-but" name="" id="" value="" onclick="location='/talent?type=' + document.getElementById('queryType').value + '&name=' + document.getElementById('exactName').value;">-->
                    <input type="button" class="inp-but" name="" id="" value="" onclick="location='/talent?name=' + document.getElementById('exactName').value;">
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>

              <div class="clearfix"></div>
            </div>
            </div>

            <div class="right-nr">
              <ul  class="az-ul">
                <li style="width:40px"><a class="active" :href="'/talent?type=' + this.$route.query.type" target="_self">All</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=A'" target="_self">A</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=B'" target="_self">B</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=C'" target="_self">C</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=D'" target="_self">D</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=E'" target="_self">E</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=F'" target="_self">F</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=G'" target="_self">G</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=H'" target="_self">H</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=I'" target="_self">I</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=J'" target="_self">J</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=K'" target="_self">K</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=L'" target="_self">L</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=M'" target="_self">M</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=N'" target="_self">N</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=O'" target="_self">O</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=P'" target="_self">P</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=Q'" target="_self">Q</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=R'" target="_self">R</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=S'" target="_self">S</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=T'" target="_self">T</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=U'" target="_self">U</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=V'" target="_self">V</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=W'" target="_self">W</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=X'" target="_self">X</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=Y'" target="_self">Y</a></li>
                <li><a :href="'/talent?type=' + this.$route.query.type + '&firstChar=Z'" target="_self">Z</a></li>

              </ul>
              <div class="clearfix"></div>
              </div>

            <div class="right-nr">
            <ul v-if="noDetail==false" class="teacher-ul">
              <li v-for="item in sliceNewsList"
                  :key="item">
                  <div class="teacher-img">
                    <a :href="'/talent/detail?type=talent&id='+item.talentId" target="_self">
                      <img :src="item.IP_URL + '/ueditor/images/zoomin_'+item.picture">
                    </a>
                  </div>
                  <div class="teacher-txt" style="text-align: left;">
                    <a :href="'/talent/detail?type=talent&id='+item.talentId" target="_self">
                      {{ item.title }}
                    </a>
                    <p style="text-align: left;" v-if="item.position.indexOf(' ')>0"><b style="font-weight: bold">职位：</b>{{ item.position.substring(0, item.position.indexOf(' ')) }}</p>
                    <p style="text-align: left;" v-else><b style="font-weight: bold">职位：</b>{{ item.position }}</p>

                    <p></p>
                    <p style="text-align: left;"><b style="font-weight: bold">研究方向：</b>{{ item.direction.substring(0,34) }}</p>
                    <p></p></div>
                  <div class="clearfix"></div>
              </li>
              <li v-if="sliceNewsList.length % 2 == 1" style="background-color: white"></li>  <!-- 这里是用来占位用的 -->
            </ul>
              <ul v-if="noDetail" class="teacher-ul2">
                <li v-for="item in sliceNewsList"
                    :key="item">
                <div class="teacher-img2">
                      <img :src="item.IP_URL + '/ueditor/images/zoomin_'+item.picture">
                  </div>
                  <div class="teacher-txt2" style="text-align: left;">
                    <p style="padding-bottom: 10px;"><span style="color: rgb(12, 92, 200); font-size: 22px; padding-right: 25px; " >{{ item.title }}</span> <span style="font-size: 17px;" >{{ item.position }}</span></p>

                    <p style="text-align: left; padding-bottom: 10px;" ><span style="font-size: 17px;" >{{ item.email }}</span><span style="margin-left: 10px; font-size: 17px;" >{{ item.phone }}</span></p>

                    <p style="padding-bottom: 10px;"><span style=" font-size: 17px;" >{{ item.address }}</span></p>

                    <div style="margin-top: 10px;  width: 450px; border-bottom: 1px solid lightgrey"> </div>

                    <p style="text-align: left; padding-top: 20px; margin-bottom: 10px; "><b style="font-size: 17px; font-weight: bold">职责范围：</b></p>
                    <p v-html="item.content"></p>
                  </div>
                  <div class="clearfix"></div>
                </li>

<!--                <li>
                  <div class="teacher-img2">
                    <img src="https://transmed-data.sjtu.edu.cn/ueditor/images/zoomin_1450688234794381314.png">
                  </div>
                  <div class="teacher-txt2" style="text-align: left;">
                    顾宏周
                    <p style="text-align: left;" ><b style="font-weight: bold">职位：</b>诊断试剂开发技术中心副主任</p>

                    <p></p>
                    <p style="text-align: left;"><b style="font-weight: bold">研究方向：</b>DNA纳米技术和核酸类分子探针</p>
                    <p></p></div>
                  <div class="clearfix"></div>
                </li>-->
              </ul>
            </div>
            <p>&nbsp;</p>
            <el-pagination background
                           @current-change="handleCurrentChange"
                           layout="prev, pager, next"
                           :page-size="10"
                           :total="count">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.sliceNewsList = this.newsList.slice((this.currentPage-1) * this.pageSize, this.currentPage * this.pageSize);
      console.log(`当前页: ${val}`);
    },

    btnMenu() {
      // 点击时隐藏
      this.isShow = !this.isShow
    },
    btnMenu2() {
      // 点击时隐藏
      this.isShow2 = !this.isShow2
    }
  },

  data () {
    return {
      pageSize: 10,
      newsList: [],
      count:0,
      sliceNewsList: [],
      categoryList: [],
      isShow: false,
      isShow2: false,
      noDetail: false,
      talentHight: 2500
    };
  },
  mounted () {
    // 分类
    this.categoryList = [
      {
        linkUrl: "#news",
        name: "全部"
      },
      {
        linkUrl: "/news#news",
        name: "新闻资讯"
      },
      {
        linkUrl: "/cooperations#cooperations",
        name: "合作动态"
      }

    ]
    // 新闻列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;
    this.noDetail = false;
    if(this.$route.query.type == "sskxj") {
      self.type = "设施科学家";
      document.getElementById('queryType').value = "sskxj";
    }else if(this.$route.query.type == "sskxjzl") {
      self.type = "设施科学家助理";
      document.getElementById('queryType').value = "sskxjzl";
    }else if(this.$route.query.type == "sysoffice") {
      self.noDetail = true; //没有 detail 页
      self.isShow2 = true;
      self.type = "实验室与技术平台办公室";
      document.getElementById('queryType').value = "sysoffice";
    }else if(this.$route.query.type == "kxyjoffice") {
      self.noDetail = true; //没有 detail 页
      self.isShow2 = true;
      self.type = "科学研究办公室";
      document.getElementById('queryType').value = "kxyjoffice";
    }else if(this.$route.query.type == "rlzyoffice") {
      self.noDetail = true; //没有 detail 页
      self.isShow2 = true;
      self.type = "人力资源办公室、学生培养办公室";
      document.getElementById('queryType').value = "rlzyoffice";
    }else if(this.$route.query.type == "zhoffice") {
      self.noDetail = true; //没有 detail 页
      self.isShow2 = true;
      self.type = "综合办公室";
      document.getElementById('queryType').value = "zhoffice";
    }else if(this.$route.query.type == "dwoffice") {
      self.noDetail = true; //没有 detail 页
      self.isShow2 = true;
      self.type = "对外合作办公室";
      document.getElementById('queryType').value = "dwoffice";
    }else
      self.type = "搜索结果"; //技术中心主任
    $.ajax({
      url:  Header.IP_URL + '/talent/simpleList?type=' + this.$route.query.type + "&firstChar=" + (this.$route.query.firstChar=='undefined'?'':this.$route.query.firstChar)+ "&name=" + (this.$route.query.name=='undefined'?'':this.$route.query.name),
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.newsList = res.data;
      self.count = res.count;
      self.sliceNewsList = self.newsList.slice(0, self.pageSize);
      if(self.type == "设施科学家" || self.sliceNewsList[0].type == 'sskxj'){
        if(self.sliceNewsList.length != 0) {
          self.talentHight = (self.sliceNewsList.length / 2 + 1) * 240 + 300;
        }else{
          self.talentHight = 650;
        }
      }else {
        self.noDetail = true; //没有 detail 页
        if(self.sliceNewsList.length != 0) {
          self.talentHight = self.sliceNewsList.length * 450 + 350;
        }else{
          self.talentHight = 650;
        }
      }

      for(var i=0;i < self.newsList.length; i++){
        if(self.newsList[i].picture == null || self.newsList[i].picture =="") {
          self.newsList[i].picture = "default_new_pic.jpg";
        }
        if(self.newsList[i].direction.length>30){
          self.newsList[i].direction = self.newsList[i].direction.substring(0,29)+"...";
        }
        self.newsList[i].IP_URL = Header.IP_URL;
      }
      for(var i=0;i < self.sliceNewsList.length; i++){
        var content = self.sliceNewsList[i].content;
        content = content.replace("职责范围", "zzfw");
        content = content.replace(/[\n]/g, "<BR><div style='margin-bottom: 8px;'></div> ");

        content = $.parseJSON(content).zzfw;

        self.sliceNewsList[i].content = content;
      }
    }).fail(function () {
      console.log('失败');
    });
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};

</script>
<style lang="scss" scoped>
.b-banner-con{
  //padding: 22px 0;
  background: url(../../assets/img/banner_bg.png) no-repeat!important;
  background-size: cover!important;
  .b-header{
    margin-bottom: 0px;
  }
}
//分类列表
.b-category {
  display: flex;
  align-items: center;
  border: 1px solid #f4f4f4;
  padding: 10px;
  margin-bottom: 20px;
  .b-title {
    color: #838383;
    font-size: 14px;
    font-weight: normal;
    font-family: microsoft yahei;
    text-decoration: none;
  }
  .b-categoryList {
    ul {
      display: flex;
      align-items: center;
      .b-cate a{
        color: #333;
        font-size: 14px;
        font-family: microsoft yahei;
        padding: 2px 6px;
        margin: 0 10px;
        &:hover {
          color: #fff;
          background-color: #37617f;
        }
      }
    }
  }
}

/******左侧导航******/

.main-left {
  float: left;
  width: 16%;
  height: 600px;
  margin-right: 105px;

  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }

  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 35px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }
  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {
    border-bottom: solid 1px #c6dbf5;
    border-right: solid 1px #c6dbf5;
    text-align: left;
  }
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 10px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;
    color: #f2f7ff;
    font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f;
    text-decoration:none;
    background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;
    border-top: solid 1px #c6dbf5;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
    padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}

}

/******右侧样式******/
.main-right {
  float: left;
  width: 72%;
  //position: relative;
  margin-top: 30px;
  min-height: 600px;
}
/*左侧导航：*/

/*左侧导航：*/

.side-nav-panel_talent {
  // background: #f1f4f7 url(../images/leftbg.jpg) no-repeat left bottom;
  background: #f1f4f7;
  padding-bottom: 50px;
  padding-top: 30px;
}

.nav-panel-title {
  font-size: 22px;
  color: #fff;
  min-height: 72px;
  //background: #00274b url(../images/ntbg.png) no-repeat right center;
  background: rgb(12, 92, 200);
  padding-left: 35px;
  padding-top: 20px;
  text-align: left;
}

.nav-panel-title i {
  width: 107px;
  height: 3px;
  background: #fff;
  display: block;
  margin-top: 14px;
}




.slide-nav-ul_talent {
  margin-left: 5px;
}

.slide-nav-ul_talent li:first-child {
  /* border-top: none; */
}

.slide-nav-ul_talent li {
  //position: relative;
  /*border-bottom: 1px solid #bbb;*/
}

.slide-nav-ul_talent li.js-item {
  margin-bottom: 0px;
}

.slide-nav-ul_talent li a {
  color: #000;
  display: block;
  position: relative;
  font-size: 18px;
  padding: 20px 0px 20px 0px;
  line-height: 22px;
  text-decoration: none;
}


/* 左侧二级选中 .parent */
.slide-nav-ul_talent li a:hover, .slide-nav-ul_talent li a.active, .slide-nav-ul_talent li a.selected, .slide-nav-ul_talent li a.parent {
  font-weight: bold;
  color: #00446a;
}


/*内页三级导航*/
.slide-nav-item-ul1 {
  display: none;
}

.slide-nav-item-ul {

}

.slide-nav-item-ul li {
  line-height: 26px;
  border: none;
  padding: 0px;
  display: block;
}

.slide-nav-item-ul li:hover {
  border-bottom: none;
}

.slide-nav-item-ul li a {
  display: block;
  color: #000;
  font-weight: normal;
  font-size: 18px;
  padding: 10px 0px 10px 40px;
  line-height: 22px;
  border: none;
  background: none;
}


/* 三级选中 .selected */
.slide-nav-ul_talent li .slide-nav-item-ul li a:hover, .slide-nav-ul_talent li .slide-nav-item-ul a.active, .slide-nav-ul_talent li .slide-nav-item-ul a.selected {
  font-weight: normal;
  color: #00446a;
}


/*右侧内容*/
.right-nr {
  font-size: 16px;
  color: #000;
  position: relative;
  margin-top: 15px;
  padding-bottom: 50px;
}

/* 师资列表 */
.teacher-ul {
}

.teacher-ul li {
  padding: 15px;
  margin-bottom: 30px;
  background: #f5f5f5;
  width: 48%;
  float: left;
  margin-right: 4%;
  height: 240px;
}

.teacher-ul li:nth-child(even) {
  margin-right: 0%;
}

.teacher-ul .teacher-img {
  width: 33%;
  float: left;
}

.teacher-ul .teacher-txt {
  width: 67%;
  padding-left: 5%;
  float: left;
}

.teacher-ul .teacher-txt a {
  font-size: 22px;
  color: rgb(12, 92, 200);
  margin-bottom: 30px;
  display: block;
}

.teacher-ul .teacher-txt p {
  color: #000;
  line-height: 24px;
  margin: 10px 0;
}


/* 师资列表 */
.teacher-ul2 {
}

.teacher-ul2 li {
  padding: 20px 10px 30px 10px;
  margin-bottom: 0px;
  width: 99%;
  float: left;
  margin-right: 4%;
  height: 100%;
  border:10px solid rgba(201,201,201,0.18);
}

.teacher-ul2 .teacher-img2 {
  padding-left: 20px;
  width: 20%;
  float: left;
  //height: 187px;
  overflow: hidden;
}

.teacher-ul2 .teacher-txt2 {
  width: 75%;
  padding-left: 5%;
  float: left;
}

/* end */

/*search talent*/
.main-tcc {
  margin-top: 20px;
}

.m-p p {
  font-size: 16px;
  line-height: 58px;
}

.main-css .searchbg1 {
  background: url(../../assets/img/ss1.png) no-repeat left top;
  width: 230px;
  height: 58px;
}

.main-css .searchbg1 input.inp-text {
  width: 178px;
  line-height: 58px;
  padding-left: 15px;
  background: none;
  border: none;
}

.main-css .searchbg1 input.inp-but {
  width: 47px;
  height: 58px;
  cursor: pointer;
  background: none;
  border: none;
}
.fl {
  float: left;
}

.fr {
  float: right;
}

/*字母序列表*/
.az-ul li {
  padding: 8px;
  margin-bottom: 10px;
  width: 31px;
  float: left;
  height: 55px;
  font-weight: bold;
  color: #00446a;
  border-top: 1px solid #cfd9eb;
}

.az-ul li a {
  //color: #00446a;
  font-size: 16px;
  text-decoration: none;
}

.az-ul li a:hover, .az-ul li a.active {
//  color: #00446a;
}

</style>



// WEBPACK FOOTER //
// src/pages/talent/index.vue